
import { IDataBooking } from "../../models/entities/IDataBooking";
import { IDataBookingPost } from "../../models/entities/IDataBookingPost";
import http from "../http-common";
import axios from "axios";
import { ISelectedDay, ISelectedDayPost } from "../../models/entities/ISelectedDay";


const getAllBooking = (token:string) => {
  return http.get<IDataBooking[]>("/reservations",{ headers: { Authorization: "Bearer " + token } });
}

const getBookingById = (id: number, token: string) => {
  return http.get<IDataBooking>(`/reservations/${id}`, { headers: { Authorization: "Bearer " + token } });
};

const getAllBookingByDates = (startDate: string, token: string) => {
  return http.get<IDataBooking[]>(`/reservations/date?date=${startDate}`, {
    headers: { Authorization: "Bearer " + token },
  });
};

const post = (data: IDataBookingPost) => {
  return http.post<any>("/reservations", data);
};
const update = (data: IDataBooking, token: string) => {
  return http.put<any>("/reservations", data, { headers: { Authorization: "Bearer " + token } });
};

const remove = (id: number,token:string) => {
  return http.delete<any>(`/reservations/${id}`, { headers: { Authorization: "Bearer " + token } });
};


const getAllBlockedDay = (token: string) => {
  return http.get<ISelectedDay[]>('/blocked-days', {
    headers: { Authorization: "Bearer " + token }
  });
};

const postBlockedDay = (data: ISelectedDayPost, token: string) => {
  return http.post<ISelectedDay>('/blocked-days', data, {
    headers: { Authorization: "Bearer " + token }
  });
};

const removeBlockedDay = (id: number, token: string) => {
  return http.delete<any>(`/blocked-days/${id}`, {
    headers: { Authorization: "Bearer " + token }
  });
};


const BookingService  = {
  getAllBooking,
  getBookingById,
  getAllBookingByDates,
  post,
  update,
  remove,
  getAllBlockedDay,
  postBlockedDay,
  removeBlockedDay
};
  
export default BookingService;